/* eslint-disable complexity */
import {
  BookWidgetAirport,
  BookWidgetAirportField
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { GeoLocationResponse } from '../../models/core-apis/geo-location.interfaces';
import { RetrieveSearchData } from '../../models/core-apis/retrieve-search.interfaces';

import { maxFlightCountForMc } from '../../constants/common.constants';
import { BffGeolocationErrortext } from '../../constants/fields-rules.constants';
import { BookWidgetFlexData } from '../../models/states/book-widget-state.interfaces';
import { QueryParams } from '../../models/states/query-params-state.interfaces';

export const prepareAirportsField = (
  geoLocationData: GeoLocationResponse | null,
  queryParams: QueryParams | null,
  retrieveSearchData: RetrieveSearchData | null,
  hasDeepLinkingParams: boolean,
  bookWidgetFlexData: BookWidgetFlexData | null
): BookWidgetAirportField => {
  let airports: BookWidgetAirport[] = [
    { fromAirportcode: '', fromCity: '', toAirportcode: '', toCity: '' }
  ];

  if (
    bookWidgetFlexData?.originAirportCode &&
    bookWidgetFlexData?.destinationAirportCode
  ) {
    airports = [
      {
        fromAirportcode: bookWidgetFlexData.originAirportCode || '',
        fromCity: bookWidgetFlexData.originAirportCity || '',
        toAirportcode: bookWidgetFlexData.destinationAirportCode || '',
        toCity: bookWidgetFlexData.destinationAirportCity || ''
      }
    ];
  } else if (queryParams?.originCity || queryParams?.destinationCity) {
    airports = [
      {
        fromAirportcode: queryParams?.originCity || '',
        fromCity: '',
        toAirportcode: queryParams?.destinationCity || '',
        toCity: ''
      }
    ];
  } else if (!hasDeepLinkingParams) {
    if (retrieveSearchData?.airports?.length) {
      airports = retrieveSearchData.airports;
    } else if (geoLocationData) {
      let cityName = geoLocationData.cityname || '';
      if (cityName && geoLocationData.statecode) {
        cityName = `${cityName}, ${geoLocationData.statecode}`;
      }
      airports = [
        {
          fromAirportcode:
            //TODO : raied a defect to BFF so that empty should be send instead of valid string
            // The BFF sometimes returns 'No Airport Found' as the airportcode
            // when it cannot determine the airport code based on the user's location.
            // In this case, we set the fromAirportcode to an empty string.
            // Additionally, we check if the airportcode length is exactly 3 characters,
            // as airport codes are typically 3 letters long. If the length is not 3,
            // we also set the fromAirportcode to an empty string.
            geoLocationData.airportcode === BffGeolocationErrortext ||
            geoLocationData.airportcode.length !== 3
              ? ''
              : geoLocationData.airportcode,
          fromCity: cityName,
          toAirportcode: '',
          toCity: ''
        }
      ];
    }
  }

  const airportsField: BookWidgetAirportField = {
    airports,
    showAddFlightBtn: airports.length < maxFlightCountForMc,
    showRemoveFlightBtn: airports.length > 2
  };

  return airportsField;
};
